/**
 * Copyright © 2026 Adnuntius AS.
 */
import {ChangeDetectorRef, Component, Inject, NgZone} from '@angular/core';
import template from './trigger-edit-page.component.html';
import {AppEventBusService} from '../common/events/app-event-bus.service';

import {AdminResourceEditPageBase} from '../common/controller/admin-resource-edit-page-base';
import {VisitorProfileFields} from '../../components/api/resources/resource/visitor-profile-fields';
import {TriggerFormLogic, TriggerFormLogicDeps} from './trigger-form-logic';
import {FolderResource} from '../../components/api/resources/resource/folder.resource';
import {AdnTimeShifterService} from '../../components/util/adn-time-shifter.service';
import {LocalNetworkProfile} from '../../components/session/local-network-profile';
import {LocationResource} from '../../components/api/resources/resource/location';
import {SearchResource} from '../../components/api/resources/resource/search';
import {UserProfileSaverService} from '../../components/session/user-profile-saver.service';

@Component({
  standalone: false,
  selector: 'adn-trigger-edit-page',
  template
})
export class TriggerEditPageComponent extends AdminResourceEditPageBase {
  formLogic: TriggerFormLogic;

  private readonly logicDeps: TriggerFormLogicDeps;

  constructor(
    eventBus: AppEventBusService,
    @Inject(UserProfileSaverService) UserProfileSaver: any,
    @Inject(LocalNetworkProfile) LocalNetworkProfile: any,
    @Inject(AdnTimeShifterService) adnTimeShifter: any,
    @Inject(FolderResource) Folder: any,
    @Inject(SearchResource) searchResource: any,
    @Inject(LocationResource) locationResource: any,
    private readonly visitorProfileFields: VisitorProfileFields,
    cdr: ChangeDetectorRef,
    ngZone: NgZone
  ) {
    super(eventBus, UserProfileSaver, LocalNetworkProfile, ngZone);

    this.logicDeps = {
      adnTimeShifter,
      Folder,
      searchResource,
      visitorProfileFields: this.visitorProfileFields,
      locationResource,
      cdr
    };
  }

  protected afterInitEditingModel(): void {
    this.editingModel.helpfulCriteria = this.editingModel.helpfulCriteria || [];
    this.formLogic = new TriggerFormLogic(this.editingModel, this.logicDeps);
  }

  protected afterInitAfterSave(): void {
    if (this.formLogic?.settingUp) {
      this.formLogic.afterInitAfterSubmit();
    }
  }

  protected onBeforeSubmit(): void {
    this.formLogic?.onBeforeSubmit();
  }

  onTriggerFormChanged(): void {
    this.markExternalFormDirty();
  }
}
